import React from 'react'

import { Typography } from '@material-ui/core'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import styles from './styles'

const BannerTitle = () => {
  const { previewTexts, isFixed, isFull, isCompact } = usePrimaryBannerPreview()

  const useStyles = styles(isFixed, isFull, isCompact)
  const classes = useStyles()

  return <Typography className={classes.title}>{previewTexts.title}</Typography>
}

export default BannerTitle
